import React, { useState, useMemo } from 'react';
import { useData } from '../../context/DataContext';
import ProjectCard from '../projects/ProjectCard';
import { Filter } from 'lucide-react';

const ProjectsPage = () => {
  const { projects, isLoading } = useData();
  const [filter, setFilter] = useState('all');
  const [sortBy, setSortBy] = useState('newest');

  const filteredProjects = useMemo(() => {
    let result = [...projects];

    // Filter by status
    if (filter === 'biten') {
      result = result.filter((p) => p.status === 'Biten');
    } else if (filter === 'devam') {
      result = result.filter((p) => p.status === 'Devam Eden');
    }

    // Sort
    if (sortBy === 'newest') {
      result = result.reverse();
    }

    return result;
  }, [projects, filter, sortBy]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-gold/30 border-t-gold rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-anthracite">
      {/* Hero */}
      <section className="relative py-24 bg-anthracite-light">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <span className="text-gold text-sm font-semibold tracking-widest uppercase">
              Portföyümüz
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mt-4">
              Projelerimiz
            </h1>
            <p className="text-gray-400 mt-4 max-w-2xl mx-auto">
              Yıllardır gerçekleştirdiğimiz projelerle binlerce aileye güvenli ve modern yaşam alanları sunduk.
            </p>
            <div className="w-24 h-1 bg-gold mx-auto mt-6" />
          </div>
        </div>
      </section>

      {/* Filters */}
      <section className="py-8 border-b border-gold/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
            <div className="flex items-center space-x-2">
              <Filter className="w-4 h-4 text-gold" />
              <span className="text-sm text-gray-400">Filtrele:</span>
              <div className="flex space-x-2">
                <button
                  onClick={() => setFilter('all')}
                  className={`px-4 py-1.5 text-sm rounded transition-all duration-300 ${
                    filter === 'all'
                      ? 'bg-gold text-anthracite font-medium'
                      : 'text-gray-400 hover:text-gold'
                  }`}
                >
                  Tümü
                </button>
                <button
                  onClick={() => setFilter('biten')}
                  className={`px-4 py-1.5 text-sm rounded transition-all duration-300 ${
                    filter === 'biten'
                      ? 'bg-gold text-anthracite font-medium'
                      : 'text-gray-400 hover:text-gold'
                  }`}
                >
                  Biten
                </button>
                <button
                  onClick={() => setFilter('devam')}
                  className={`px-4 py-1.5 text-sm rounded transition-all duration-300 ${
                    filter === 'devam'
                      ? 'bg-gold text-anthracite font-medium'
                      : 'text-gray-400 hover:text-gold'
                  }`}
                >
                  Devam Eden
                </button>
              </div>
            </div>

            <div className="flex items-center space-x-2">
              <span className="text-sm text-gray-400">Sırala:</span>
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="bg-anthracite-light text-gray-300 text-sm px-3 py-1.5 rounded border border-gold/20 focus:border-gold focus:outline-none"
              >
                <option value="newest">En Yeni</option>
                <option value="oldest">En Eski</option>
              </select>
            </div>
          </div>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProjects.length === 0 ? (
            <div className="text-center py-16">
              <p className="text-gray-400">Bu kriterlere uygun proje bulunamadı.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map((project) => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;